import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=05167a25"
import script from "./Submit.vue?vue&type=script&lang=js"
export * from "./Submit.vue?vue&type=script&lang=js"
import style0 from "./Submit.vue?vue&type=style&index=0&id=05167a25&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports